module.exports = {"360726100":"欣山镇","360726101":"孔田镇","360726102":"版石镇","360726103":"天心镇","360726104":"龙布镇","360726105":"鹤子镇","360726106":"三百山镇","360726107":"车头镇","360726200":"镇岗乡","360726201":"凤山乡","360726202":"新龙乡","360726203":"蔡坊乡","360726204":"重石乡","360726205":"长沙乡","360726206":"浮槎乡","360726207":"双芫乡","360726208":"塘村乡","360726209":"高云山乡","360726400":"九龙工业园"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360726.json
// module id = 1406
// module chunks = 0